import('./card.css')

export default function Card(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    this.generate = (options) =>{
        $(elements.content).html('')
        if(options.contents){
            options.contents.forEach(content=>{
                let el = this.createElement('div', 'modal-info-card-wrapper')
                $(el).append('<div class="modal-info-card-value">' + content.value + '</div><div class="modal-info-card-title">' + content.title + '</div><div class="modal-info-card-footer text-muted">' + (content.footer || "") + '</div>')
                if(content.tooltip){
                    tippy(el, {
                        content: content.tooltip.text,
                    });
                }
                $(elements.content).append(el)
            })
        } else {
            //     
            $(elements.content).html('<div class="modal-info-card-value">' + options.content + '</div>')
        }
        
    }

    this.update = () =>{

    }

    init()

    function init(){
        elements.container = context.createElement('div', 'modal-info-card', '')
        elements.content = context.createElement('div', 'modal-info-card-content', '')
        elements.title = context.createElement('div', 'modal-info-card-title', opts.title)

        $(elements.container).append(elements.content)

        $(container).append(elements.container)
    }
}

Card.prototype = Object.create(BaseConstructor.prototype)